<script>
  export default {
    props: {
      acessoTipos: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        imagemCover: '',
        acessoRota: '',
        subtitulo: '',
      }
    },
    methods: {
      retornaImagem(acessoTipo) {
        if (acessoTipo.imagem) {
          return acessoTipo.imagem;
        }

        return this.imagemCover;
      },
      configuraTipo() {
        switch (this.$route.name) {
          case 'acessos.cursos':
            this.imagemCover = 'img/acesso/atalhos/curso_cover.png';
            this.acessoRota = 'acessos.cursos-detalhamento';
            break;
          case 'acessos.eventos':
            this.imagemCover = 'img/acesso/atalhos/evento_cover.png';
            this.acessoRota = 'acessos.eventos-detalhamento';
            break;
          case 'acessos.servicos':
            this.imagemCover = 'img/acesso/atalhos/evento_cover.png';
            break;
          case 'acessos.doacoes':
            this.imagemCover = 'img/acesso/atalhos/doacao_cover.png';
            this.acessoRota = 'acessos.doacoes-detalhamento';
            break;
          case 'acessos.licitacoes':
            this.acessoRota = 'acessos.licitacoes-detalhamento';
            break;
          default:
            this.$router.push('/acessos');
        }
      },
    },
    computed: {
    },
    mounted() {
      
    },
    created() {
      this.configuraTipo();
    }
  }
</script>

<template>
  <div>
    <div v-for="(acessoTipo, index) in acessoTipos">
      <article class="well listing-item">
        <router-link active-class=""
                     :to="{ name: acessoRota, params: { id: acessoTipo.idSolicitacaoCript } }">

          <div class="media-left listing-item__logo">
            <img class="media-object profile__img-company" :src="retornaImagem(acessoTipo)">
          </div>

          <div class="media-body-local">
            <div class="media-heading listing-item__title">
              {{ acessoTipo.descricao }} 
            </div>
            <div class="listing-item__date">
              {{ subtitulo }} {{ acessoTipo.subTitulo }}
            </div>
            <div class="listing-item__desc">
              {{ acessoTipo.resumo }}
            </div>
          </div>

        </router-link>
      </article>
    </div>
  </div>
</template>

<style scoped>
  .listing-item {
    margin: 0 auto 20px;
    display: block;
    width: 85%;
  }

  .listing-item__date {
    color: rgba(62, 62, 62, 0.3);
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 14px;
    white-space: nowrap;
  }

  .listing-item__desc {
    text-overflow: ellipsis;
    margin-top: 8px; 
    height: 44px;
    padding-right: 21px;
    line-height: 24px;
    margin-bottom: 6px;
    overflow: hidden;
    max-width: 700px;
    word-break: break-word;
  }

  .media-left {
    padding-right: 10px;
  }

  @media (min-width: 768px) {
    .media-body-local, .media-left {
      display: table-cell;
      vertical-align: top;
    }
  }

  @media (max-width: 768px) {

    .media-left {
      display: table-cell;
      vertical-align: top;
    }

    .media-body-local {
      margin-top: 10px;
    }
  }

  .listing-item__title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 8px;
  }

  .listing-item__logo {
    vertical-align: middle;
    min-width: 150px;
    width: 150px;
    text-align: center;
    position: relative;
  }

  .listing-item__logo .media-object:not(.profile__img) {
    max-width: 125px;
    max-height: 125px;
    margin-right: 15px;
    display: inline-block;
  }

  .profile__img-company {
    border-radius: 6px;
    width: 115px;
    height: 115px;
  }

  .well {
    min-height: 20px;
    padding: 19px;
    margin-bottom: 20px;
    background-color: #f5f5f5;
    border: 1px solid #e3e3e3;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
  }

  .well {
    border-radius: 6px;
  }

  .listing-item {
    min-width: 310px;
    min-height: 104px;
    background-color: #fff;
    box-shadow: none;
    -webkit-transition: box-shadow 0.2s ease-in;
    -moz-transition: box-shadow 0.2s ease-in;
    -o-transition: box-shadow 0.2s ease-in;
    transition: box-shadow 0.2s ease-in;
  }
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessoTipos.vue